import Env from '@/common/constants/Env.json';
import EnvStage from '@/common/constants/Env_stage.json';
import EnvProd from '@/common/constants/Env_prod.json';
import EnvDev from '@/common/constants/Env_dev.json';
import store from '@/store';
import { computed } from 'vue';
import { TERMS_KANPANON_V1 } from '@/views/terms/termsKanpanonV1.js';

export const CRY_USER_BACKGROUND_PASS = 'com.appg.lifeendlife.user_bgi';

export const SMILE_TYPE = {
  WEDDING: { key: 'WEDDING', name: '결혼식' },
  HUNDRED: { key: 'HUNDRED', name: '돌잔치, 백일잔치' },
  OLDER: { key: 'OLDER', name: '육순, 칠순, 팔순, 구순, 백세 행사' },
  HAPPY_BIRTH: { key: 'HAPPY_BIRTH', name: '생일 축하' },
  OPEN_STORE: { key: 'OPEN_STORE', name: '개업식' },
  CHRIST: { key: 'CHRIST', name: '세례식' }
};

export const SMILE_TYPE_TEXT = {
  WEDDING: { key: 'WEDDING', name: '결혼식' },
  HUNDRED: { key: 'HUNDRED', name: '돌잔치, 백일잔치' },
  OLDER: { key: 'OLDER', name: '육순, 칠순, 팔순, 구순, 백세 잔치' },
  HAPPY_BIRTH: { key: 'HAPPY_BIRTH', name: '생일잔치' },
  OPEN_STORE: { key: 'OPEN_STORE', name: '개업식' },
  CHRIST: { key: 'CHRIST', name: '세례식' }
};

export const SmileRelationDefaults = {
  [SMILE_TYPE.WEDDING.key]: {
    firstRelation: [
      { relation: '부', name: '' },
      { relation: '모', name: '' }
    ],
    secondRelation: [
      { relation: '부', name: '' },
      { relation: '모', name: '' }
    ]
  },
  [SMILE_TYPE.HUNDRED.key]: {
    firstRelation: [{ relation: '부모', name: '' }]
  },
  [SMILE_TYPE.OPEN_STORE.key]: {
    firstRelation: [{ relation: '자녀', name: '' }]
  },
  [SMILE_TYPE.OLDER.key]: {
    firstRelation: [{ relation: '자녀', name: '' }]
  },
  [SMILE_TYPE.CHRIST.key]: {
    firstRelation: [{ relation: '자녀', name: '' }]
  },
  [SMILE_TYPE.HAPPY_BIRTH.key]: {
    firstRelation: [{ relation: '자녀', name: '' }]
  }
};

export const CRY_TYPE = {
  MEMORIAL_IN: { key: 'MEMORIAL_IN', name: 'Inside' },
  MEMORIAL_OUT: { key: 'MEMORIAL_OUT', name: 'Outside' },
  ANDERSEN: { key: 'ANDERSEN', name: '안데르센' },
  ANNOUNCEMENT: { key: 'ANNOUNCEMENT', name: '온라인 부고장' },
  FUNERAL: { key: 'FUNERAL', name: '온라인 장례식장' }
};

// MEMO: 웰다잉 코드
export const WELL_DYING_CODE_LIST = [
  // { key: 'WILL', value: '유서' },
  // { key: 'FAMILY_LETTER', value: '가족에게 남기는 글' },
  // { key: 'THANKS', value: '감사의 편지' },
  { key: 'WELL_FAMILY', value: 'Family Together' },
  { key: 'WELL_GOD', value: 'God Together' },
  { key: 'WELL_PRAY', value: 'Pray Together' }
  // FAMILY_ROOM: { key: 'FAMILY_ROOM', label: '가족 공동방' }
];

export const WELL_DYING_CODE = {
  // WILL: { key: 'WILL', name: '유서' },
  // FAMILY_LETTER: { key: 'FAMILY_LETTER', name: '가족에게 남기는 글' },
  // THANKS: { key: 'THANKS', name: '감사의 편지' },
  WELL_FAMILY: { key: 'WELL_FAMILY', name: 'Family Together' },
  WELL_GOD: { key: 'WELL_GOD', name: 'God Together' },
  WELL_PRAY: { key: 'WELL_PRAY', name: 'Pray Together' }
};

export const CALCULATE_TYPE = {
  CASH: { key: 'CASH', name: '입금' },
  POINT: { key: 'POINT', name: '포인트' }
};

export const AUTHENTICATE_STATUS = {
  WAITING: {
    value: '대기',
    key: 'WAITING'
  },
  SUCCESS: {
    value: '승인',
    key: 'SUCCESS'
  },
  FAIL: {
    value: '거절',
    key: 'FAIL'
  }
};

export const IN_APP_PRODUCT_ID = {
  EMOTICON: 'test123.com.appg.LifeENDLife1',
  MEMORIAL: 'test123.com.appg.LifeENDLife1',
  ANDROID: 'item_test_01'
};

export const IMAGE_MAX_SIZE = 30;
export const MEMORIAL_TYPE = {
  OUTSIDE: 'Outside',
  INSIDE: 'Inside',
  ANDERSEN: 'ANDERSEN'
};

export const BOTTOM_SHEET = {
  BUSINESS: 'BUSINESS',
  BUSINESS_SEARCH: 'BUSINESS_SEARCH'
};
export const defaultPaging = {
  page: 1,
  limit: 10,
  totalPage: 1
};

export const USER_GRADE = {
  F: {
    key: 'F',
    label: '무료'
  },
  BETA: {
    key: 'BETA',
    label: '베타'
  },
  BC: {
    key: 'BC',
    label: '베이직'
  },
  BC_PASS: {
    key: 'BC_PASS',
    label: '베이직 이용권'
  },
  P: {
    key: 'P',
    label: '프리미엄'
  },
  P_PASS: {
    key: 'P_PASS',
    label: '프리미엄 이용권'
  }
};

export const SMILE_COMMENT = {
  WEDDING: [
    { content: '두 분 영원히 행복하세요!' },
    { content: '사랑이 가득한 결혼을 축하드립니다' },
    { content: '백년해로 하세요' },
    { content: '행복한 가정 이루세요' },
    { content: '결혼을 진심으로 축하드립니다' },
    { content: '영원한 사랑 응원해요' },
    { content: '늘 지금처럼 행복하시길' },
    { content: '드디어 결혼이라니! 축하해요' },
    { content: '꿀이 뚝뚝 떨어지네요' },
    { content: '신랑, 신부 우주에서 제일 멋지고 아름다워요!' },
    { content: '드디어 솔로 종착역! 부럽습니다 진심!!' },
    { content: '꽃길만 걸으세요' },
    { content: '이 아름답고 완벽한 조합 찬성입니다' },
    { content: '예쁘게 잘 사세요' },
    { content: '잘 살아라 친구야' },
    { content: '주님의 이름으로 두 분의 결혼을 축복합니다' },
    { content: '하나님이 세우신 가정 위에 은혜가 가득하길 바랍니다' },
    { content: '믿음 안에서 사랑하는 가정 되시길 기도합니다' },
    { content: '하나 되어 주님을 따르는 가정이 되길 축복해요' },
    { content: '주님의 사랑으로 평생 동행하시길 바랍니다' }
  ],
  HUNDRED: [
    { content: '우리 아기 백일 축하해' },
    { content: '첫생일 축하해요!' },
    { content: '귀요미 첫생일 너무너무 축하해요' },
    { content: '사랑 듬뿍 받으렴' },
    { content: '엄마 아빠도 고생했어요' },
    { content: '건강하게 무럭무럭 자라렴' },
    { content: '세상에서 제일 귀여운 아기가 여기 있어요' },
    { content: '꺄악! 완전 축하해요 귀요미' },
    { content: '아가야 세상에 와줘서 정말 고마워' },
    { content: '햇살 같은 너의 첫 생일 축하한다' },
    { content: '뽀짝한 네 웃음에 심쿵' },
    { content: '네가 자라는 모든 순간이 행복이란다' },
    { content: '이렇게 귀여운거는 반칙이지!' },
    { content: '밝고 따뜻한 사람이 되기를' },
    { content: '인형 아니고 진짜 아기 맞는거지?' },
    { content: '아이 위에 주님의 보호하심이 함께하시길 기도합니다.' },
    { content: '귀한 생명, 주의 기쁨이 되길 축복합니다' },
    { content: '아이와 함께 가정 안에 은혜가 넘치길 바랍니다' },
    { content: '밝고 건강하게 자라는 아이가 되길 기도합니다' },
    { content: '주님의 인도하심이 모든 날에 함께하길 소망합니다' }
  ],
  HAPPY_BIRTH: [
    { content: '생일 진심으로 축하해!' },
    { content: '행복한 하루 보내세요' },
    { content: '매년 더 예뻐지네~' },
    { content: '축하해요! 늘 행복하길' },
    { content: '태어나줘서 고마워' },
    { content: '케이크만큼 달콤한 하루 보내세요' },
    { content: '축하해요! 더 멋진 날들만 가득하세요' },
    { content: '세상에 와줘서 고마워' },
    { content: '생일 정말 정말 축하드립니다' },
    { content: '사랑 가득한 하루 되세요' },
    { content: '당신이 옆에 있어서 행복합니다' },
    { content: '진심으로 축복합니다. 사랑합니다' },
    { content: '행복이 늘 당신의 곁에 있기를' },
    { content: '언제나 빛나는 당신이 되길' },
    { content: '함께한 시간에 감사합니다. 축하해요' },
    { content: '생일을 맞아 하나님의 사랑이 충만하길 축복합니다.' },
    { content: '주님의 은혜가 오늘도 삶을 감싸길 기도합니다' },
    { content: '하나님이 지으신 귀한 날, 진심으로 축하드립니다' },
    { content: '당신이 이 땅에 태어난 그 자체가 하나님의 기쁨입니다' },
    { content: '하나님과 함께 기쁨 충만한 하루 되시길 축복합니다' }
  ],
  OLDER: [
    { content: '생신 진심으로 축하드립니다' },
    { content: '건강하게 오래오래 사세요' },
    { content: '사랑과 은혜에 감사드립니다' },
    { content: '행복과 축복이 가득하시길' },
    { content: '가족의 기둥! 감사합니다' },
    { content: '건강이 최고입니다. 축하드려요' },
    { content: '당신의 사랑과 헌신에 감사드립니다' },
    { content: '귀한 걸음 오래도록 이어가시길' },
    { content: '존경합니다. 감사합니다. 사랑합니다' },
    { content: '항상 웃음과 행복이 가득하세요' },
    { content: '늘 자랑스럽습니다. 우리 부모님' },
    { content: '저희 곁에 있어주셔서 감사해요' },
    { content: '늘 지금처럼 웃고 행복하세요' },
    { content: '저희와 함께 오래오래 건강하세요' },
    { content: '너무 자랑스럽습니다. 진심으로 축하드려요' },
    { content: '긴 세월 이끄신 주님께 감사드리며 축복합니다' },
    { content: '믿음의 걸음에 주의 평강이 함께하길 바랍니다' },
    { content: '모든 시간이 주의 은혜임을 고백합니다' },
    { content: '남은 날에도 주님의 기쁨이 넘치길 기도합니다' },
    { content: '존귀한 생애에 하나님의 영광이 드러나길 바랍니다' }
  ],
  OPEN_STORE: [
    { content: '개업을 진심으로 축하드립니다' },
    { content: '번창하시길 기원합니다' },
    { content: '대박 나세요!' },
    { content: '무궁한 발전을 기원합니다' },
    { content: '성공 가득하시길 바랍니다' },
    { content: '앞으로 승승장구 하세요' },
    { content: '꽃길만 걸으세요' },
    { content: '새 출발에 힘찬 응원을!' },
    { content: '사업에 날개를 달다!' },
    { content: '드디어 오픈! 축하해요' },
    { content: '오픈 축하합니다! 자주 갈게요' },
    { content: '대기표 뽑고 이미 웨이팅!' },
    { content: '세상 멋진 오픈 축하해요' },
    { content: '단골 예약입니다 축하해요' },
    { content: '대박 날 기운 뿜뿜입니다' },
    { content: '시작 위에 하나님의 축복이 함께하길 바랍니다' },
    { content: '정직과 사랑으로 번창하길 기도합니다' },
    { content: '주의 손길로 세워지는 일터가 되길 축복해요' },
    { content: '하나님의 빛이 이 자리에 임하길 소망합니다' },
    { content: '아름다운 열매를 맺는 기업으로 성장하길 기도합니다' }
  ],
  CHRIST: [
    { content: '세례 축하드립니다' },
    { content: '하나님의 자녀 되심을 축복해요' },
    { content: '주 안에서 축복합니다' },
    { content: '믿음의 첫걸음 축하해요' },
    { content: '주님의 은혜에 감사드립니다' },
    { content: '믿음의 가족이 되어 정말 반갑습니다' },
    { content: '주님이 늘 동행하길 기도합니다' },
    { content: '하나님의 축복이 함께하길' },
    { content: '믿음의 시작을 응원합니다' },
    { content: '신앙의 길 함께 걸어가요. 축복합니다' },
    { content: '기쁨이 가득한 세례 축하!' },
    { content: '이제 믿음안에 한가족 입니다' },
    { content: '세례 축하해요. 너무 감동입니다' },
    { content: '믿음의 여정, 출발을 진심으로 축복해요' },
    { content: '은혜로운 날, 함께 축복하고 축하합니다' },
    { content: '새로운 생명을 얻은 날을 축복합니다.' },
    { content: '하나님의 가족이 된 걸 축하드립니다' },
    { content: '성령으로 거듭난 삶에 은혜가 넘치길 바랍니다' },
    { content: '말씀 위에 세워지는 삶이 되길 기도합니다' },
    { content: '믿음의 길에 주의 동행이 늘 함께하길 바랍니다' }
  ]
};

export const defaultPageInfo = { totalPage: 2, page: 1, limit: 10, startPage: 1, endPage: 1 };
export const defaultCommentPageInfo = { totalPage: 2, page: 1, limit: 20, startPage: 1, endPage: 1 };
export const FUNERAL_BUY_LIST = computed(() => store.getters['emoticon/getBuyList']);
export const FUNERAL_EMOTICON_LIST = computed(() => store.getters['emoticon/getEmoticonList']);
export const COMMENT_LIST = computed(() => store.getters['common/getTemplates']);
export const AUDIO_FILES = [
  '20250220 구주를 생각만 해도 (85장) PIano 2.wav',
  '20250220 내 주 되신 주를 참 사랑하고 (315장) Piano 2.wav',
  '20250220 내 평생에 가는 길 (413장) Piano 2.wav',
  '20250220 예수 나를 위하여 (144장) Piano 2.wav',
  '20250220 저 장미꽃 위에 이슬 (442장) PIano 2.wav'
];

export const SMILE_AUDIO_FILES = [
  '20250624 - Salut d_Amour.mp3',
  '20250624 - Jesu, Joy of Man_s Desiring.mp3',
  '20250624 - Humoresque Op.101 No.7.mp3'
];

export const ANDERSEN_AUDIO_FILES = [
  '20250416 Piano (Hush, Little Baby).mp3',
  '20250416 Piano (Rock-a-Bye Baby).mp3',
  '20250416 Piano (고요한 밤 거룩한 밤).mp3',
  '20250416 Piano (반짝반짝 작은별).mp3',
  '20250416 Piano (브람스 자장가).mp3'
];

export const HAPPY_BIRTH_AUDIO_FILE = 'HAPPY_BIRTH.mp3';
export const WEDDING_AUDIO_FILE = 'WEDDING.mp3';

export const USER_TYPE = {
  GENERAL: {
    value: '일반',
    key: 'GENERAL'
  },
  FAMILY: {
    value: '가족',
    key: 'FAMILY'
  },
  CHURCH: {
    value: '교회',
    key: 'CHURCH'
  },
  ADMIN: {
    value: '관리자',
    key: 'ADMIN'
  }
};
export const SEARCH_TYPE_URL = {
  MEMORIAL: '/memorial',
  FUNERAL: '/funeral'
};
export const KEEP_ALIVE_OBJECT = {
  MEMORIAL: {
    expression: '/memorial',
    list: ['MEMORIAL_LIST', 'CHURCH_LIST']
  },
  MEMORIAL_SELECT: {
    expression: '/memorial/select',
    list: []
  },
  MEMORIAL_REGISTER: {
    expression: '/memorial/register',
    list: ['MEMORIAL_STEP_ONE', 'MEMORIAL_STEP_TWO', 'MEMORIAL_STEP_THREE', 'MEMORIAL_STEP_FOUR']
  },
  SIGNUP: {
    expression: '/signup',
    list: ['SIGN_UP', 'SIGN_UP_PREMIUM', 'SIGN_UP_TERMS']
  },
  FUNERAL: {
    expression: '/funeral',
    list: ['FUNERAL_LIST']
  },
  FIND_ID: {
    expression: '/find/id',
    list: ['FIND_ID', 'FIND_ID_STEP2']
  },
  FIND_PASS: {
    expression: '/find/password',
    list: ['FIND_PASS', 'FIND_PASS_STEP2', 'FIND_PASS_STEP3']
  },
  WELL_DYING: {
    expression: '/welldying',
    list: ['WELL_DYING_LIST']
  },
  BUSINESS_REGISTER: {
    expression: '/business/register',
    list: ['BUSINESS_STEP1', 'BUSINESS_STEP2', 'BUSINESS_STEP3', 'BUSINESS_TERMS']
  },

  BUSINESS_UPDATE: {
    expression: '/business/update',
    list: ['BUSINESS_STEP1', 'BUSINESS_STEP2', 'BUSINESS_STEP3']
  },
  MARKETING_REGISTER: {
    expression: '/business/marketing/register',
    list: ['MARKETING_REGISTER', 'MARKETING_PREVIEW']
  },
  DONATION_REGISTER: {
    expression: '/business/donation/register',
    list: ['DONATION_REGISTER', 'DONATION_PREVIEW']
  },
  JOB_REGISTER: {
    expression: '/business/job/register',
    list: ['JOB_REGISTER', 'JOB_PREVIEW']
  },
  BUSINESS_DETAIL: {
    expression: '/business',
    list: ['BUSINESS_MAP', 'BUSINESS_DETAIL']
  }
};

export const BUSINESS_STATUS = {
  ACTIVE: {
    value: 'ACTIVE',
    label: '활성'
  },
  TEMPORARY: {
    value: 'TEMPORARY',
    label: '임시 저장'
  },
  ADMIN_DELETE: {
    value: 'ADMIN_DELETE',
    label: '관리자 차단',
    text: '관리자에 의해 차단된 글입니다.'
  },
  DELETE: {
    value: 'DELETE',
    label: '유저 삭제'
  }
};

export let CODE_ENV_LIST = Env;
export let MODE = 'develop';
if (process.env.NODE_ENV === 'production') {
  CODE_ENV_LIST = EnvProd;
  MODE = 'production';
} else if (process.env.NODE_ENV === 'stage') {
  CODE_ENV_LIST = EnvStage;
  MODE = 'stage';
} else if (process.env.NODE_ENV === 'development') {
  CODE_ENV_LIST = EnvDev;
  MODE = 'dev';
}

export const JOIN_TYPE = {
  KAKAO: {
    value: 'KAKAO',
    label: '카카오'
  },
  NAVER: {
    value: 'NAVER'
  },
  GOOGLE: {
    value: 'GOOGLE'
  },
  APPLE: {
    value: 'APPLE'
  },
  GENERAL: {
    value: 'GENERAL'
  }
};

export const ACCESS_TOKEN_NAME = 'authorization';
export const REFRESH_TOKEN_NAME = 'refresh_token';
export const SIGN_IN_PATH = '/signin';

export const CHAT_TYPE = {
  TEXT: 'TEXT',
  EMOTICON: 'EMOTICON'
};

export const ALIVE_REPORT_LIST = [
  {
    key: '중복/도배성 게시글이에요',
    value: '중복/도배성 게시글이에요'
  },
  {
    key: '부적절한 게시글이에요',
    value: '부적절한 게시글이에요'
  },
  {
    key: '욕설/혐오 표현이 사용된 게시글이에요',
    value: '욕설/혐오 표현이 사용된 게시글이에요'
  },
  {
    key: '불건전한 게시글이에요',
    value: '불건전한 게시글이에요'
  },
  {
    key: '광고/홍보 게시글이에요',
    value: '광고/홍보 게시글이에요'
  }
];

export const SMILE_REPORT_LIST = [
  {
    key: '악의적이고 부적절한 내용이에요',
    value: '악의적이고 부적절한 내용이에요'
  },
  {
    key: '상대방에게 불쾌감을 줄수 있어요',
    value: '상대방에게 불쾌감을 줄수 있어요'
  },
  {
    key: '욕설/혐오 표현이 있어요',
    value: '욕설/혐오 표현이 있어요'
  },
  {
    key: '불건전한 내용이에요',
    value: '불건전한 내용이에요'
  },
  {
    key: '실제 내용과 달라요',
    value: '실제 내용과 달라요'
  }
];
export const MEMORIAL_SEARCH_TYPE = {
  DEAD_NAME: {
    key: '고인 성함',
    value: 'DEAD_NAME'
  },
  NAME: {
    key: '가족 성함',
    value: 'NAME'
  },
  MEMORIAL_NO: {
    key: '등록 번호',
    value: 'MEMORIAL_NO'
  },
  CHURCH: {
    key: '등록 교회',
    value: 'CHURCH'
  }
};

export const NAV_URL = () => {
  return {
    HOME: '/main',
    SEARCH: '/business',
    DIARY: `/diary`,
    MORE: '/more'
  };
};

export const MODAL_TYPE = {
  SEARCH: 'SEARCH',
  MESSAGE: 'MESSAGE',
  FAMILY: 'FAMILY',
  CHURCH: 'CHURCH',
  VALUE_LIST: 'VALUE_LIST',
  KEY_VALUE_LIST: 'KEY_VALUE_LIST'
};
export const EMOTICON_MENU = {
  SMILE: '축하하기',
  MEMORIAL: '추모하기',
  WATCH: '둘러보기',
  NORMAL: '일반'
};

export const GET_ITEM_TYPE = {
  MEMORIAL: 'MEMORIAL'
};

export const TICKET_MENU = {
  SINGLE: '1인 추모관 이용권',
  COUPLE: '부부합장 추모관 이용권'
};

export const MEMORIAL_TICKET_MENU = {
  SINGLE: '1인 추모관 이용권',
  MARRIED: '부부합장 추모관 이용권'
};

export const MEMORIAL_BACKGROUND_MENU = {
  BACKGROUND: '배경 이미지',
  PHOTO_FRAME: '액자 이미지'
};

export const BACKGROUND_IMAGE = {
  MAIN: 'bg-main',
  FUNERAL: 'bg-image02',
  FUNERAL_DETAIL: 'bg-image07',
  PHOTO: 'sample/bg-chatroom',
  MEMORIAL_INSIDE: 'bg-image01',
  MEMORIAL_OUTSIDE: 'bg-image04',
  MEMORIAL_HUMAN: 'sample/img-human',
  MEMORIAL_WOMAN: 'sample/img-woman',
  MEMORIAL_INSIDE_BACKGROUND: 'bg-image06',
  MEMORIAL_OUTSIDE_BACKGROUND: 'bg-image05'
};

// require로 동적으로 프로젝트내의 이미지를 가져올 경우 확장자까지 모두 변수로받으면 에러가발생하여
// 확장자는 분리해서 상수 처리
export const IMAGE_EXTENSTION = {
  GIF: '.gif',
  PNG: '.png'
};

export const SELECT_GNB_LIST = (callBack, url) => {
  return [
    {
      image: 'background05',
      content: `${MEMORIAL_TYPE.INSIDE} 추모관`,
      pushUrl: '/memorial/select',
      btnText: '입장하기',
      innerClass: 'widthFill height120',
      fnCallBack: () => {
        callBack(MEMORIAL_TYPE.INSIDE, url);
      }
    },
    {
      image: 'background06',
      content: `${MEMORIAL_TYPE.OUTSIDE} 추모관`,
      pushUrl: '/memorial/select',
      btnText: '입장하기',
      innerClass: 'widthFill height120',
      fnCallBack: () => {
        callBack(MEMORIAL_TYPE.OUTSIDE, url);
      }
    }
  ];
};

// MEMO: 가족제거 (생전모습)
export const MEMORIAL_GNB_LIST = (memorialNo, familyCode, userNo, historyCall) => {
  return [
    {
      content: '헌화하기',
      image: 'img-wreath',
      innerClass: 'widthFill height80 flex-justi-con-center',
      pushUrl: `/memorial/wreath/${memorialNo}`
    },
    {
      content: '생전모습',
      btnText: '입장하기',
      image: 'img-gallery',
      innerClass: 'onlineFuneral',
      pushUrl: `/memorial/alive/${memorialNo}`
    },
    {
      content: '우리가족 히스토리',
      btnText: '입장하기',
      image: 'img-familyHistory',
      innerClass: 'obituaries',
      pushUrl: `/memorial/history/${familyCode}`,
      fnCallBack: () => {
        historyCall();
      }
    }
  ];
};

export const TERMS_TEXT = {
  SERVICE: `“Life END Life” 이용약관
Life END Life이용약관 및 관련 제반 서비스의 이용과 관련하여 필요한 사항을 규정합니다.  회원약관은 다음과 같은 내용을 담고 있습니다.
 
제1조 목적
본 이용약관(이하 ‘약관’이라 함)은 (주)점프의 Life END Life (이하 ‘회사)가 이용고객(이하 ‘회원’)간에 회사가 제공하는 온라인상의 인터넷 서비스(이하 ‘서비스’)의 가입조건 및 이용에 관한 제반사항과 기타 필요한 사항을 구체적으로 규정함을 목적으로 합니다.
 
제2조 정의
이 약관에서 사용하는 용어의 정의는 다음과 같습니다.
 (1) ‘서비스’라 함은 구현되는 단말기(PC, 모니터, 휴대형단말기 등의 각종 유무선 장치를 포함)와 상관없이 ‘이용자’가 이용할 수 있는 추모의 관련 제반 서비스를 의미합니다.
 (2) ‘회원’이라 함은 ‘회사’에 개인정보를 제공하여 회원등록을 한 자로서, 회사의 서비스에 자유롭게 접속하여 정보를 지속적으로 제공받을 수 있거나 사이트가 제공하는 서비스를 계속적으로 이용할 수 있는 자를 말합니다.
 (3) ‘비회원’이라 함은 ‘회원’으로 가입하지 않고 ‘회사’가 제공하는 서비스를 이용하는 자를 말합니다.
 (4) ‘이용자’라 함은 회사의 서비스를 이용하는 자를 말하며, 회원과 비회원을 모두 포함합니다.
 (5) ‘게시물’이라 함은 ‘이용자’가 서비스를 이용함에 있어 서비스 상에 게시한 부호 • 문자 • 음성 • 음향 • 화상 • 동영상 • 초대장 • 온라인 행사장 • 부고장 • 온라인 장례식장 • 추모관 • 기업 홍보 사진/영상 등의 정보 형태의 초대장, 행사장, 부고장, 기업 소개/마케팅, 글, 사진, 동영상 및 각종 파일과 링크 등을 의미합니다.
 
제3조 약관의 게시와 개정
1. ‘회사’는 이 약관의 내용을 ‘이용자’가 알 수 있도록 ‘서비스’ 화면에 게시합니다.
2. ‘회사’는 ‘약관의 규제에 관한 법률’ ‘정보통신망 이용촉진 및 정보보호 등에 관한 법률(이하 ‘정보통신망법’) 등 관련 법률에 위배되지 않는 범위내에서 이 약관을 개정할 수 있습니다.
3. ‘회사’가 약관을 개정할 경우에는 적용일자 및 개정사유를 명시하여 제1항의 방식에 따라 그 개정약관의 적용일자 7일 이전부터 적용일자 전일까지 공지합니다. 다만, ‘이용자’에게 불리하게 약관내용을 변경하는 경우에는 최소한 30일 이상의 사전 유예기간을 두고 공지합니다. 이 경우 ‘회사’는 제1항의 방식에 따라 개정약관 내용을 ‘이용자’가 알기 쉽도록 표시합니다.
4. ‘회원’은 변경된 약관에 동의하지 않을 권리가 있으며, 변경된 약관에 동의하지 않을 경우에는 서비스 이용을 중단하고 탈퇴를 요청할 수 있습니다. 다만, ‘이용자’가 제3항의 방법 등으로 ‘회사’가 별도 고지한 약관 개정 공지 기간 내에 ‘회사’에 개정 약관에 동의하지 않는다는 명시적인 의사표시를 하지 않는 경우 변경된 약관에 동의한 것으로 간주합니다.
 
제4조 관련법령과의 관계
이 약관에서 정하지 않은 사항은 전기통신사업법, 전자거래기본법, 정보통신망법, 전자상거래 등에서의 소비자보호에 관한 법률, 개인정보보호법 등 관련 법령의 규정과 일반적인 상관례에 따릅니다.
 
제5조 이용계약의 체결
1. 이용계약은 ‘회원’이 되고자 하는 자(이하 ‘가입신청자’)가 약관의 내용에 대하여 동의를 한 다음 회원가입 신청을 하고 ‘회사’가 이러한 신청에 대하여 승인함으로써 체결됩니다.
2. ‘회사’는 ‘가입신청자’의 신청에 대하여 ‘서비스’ 이용을 승낙함을 원칙으로 하며, 성립시기는 ‘회사’가 가입완료를 신청절차 상에 표시한 시점으로 합니다.
3. 제1항에 따른 신청에 있어 ‘회사’는 ‘가입신청자’에게 전문기관을 통한 실명확인 및 본인인증을 요청할 수 있습니다.
4. ‘회사’는 서비스관련 설비의 여유가 없거나, 기술상 또는 업무상 문제가 있는 경우에는 승낙을 유보할 수 있습니다.

제6조 회원정보의 변경
‘회원’은 회원가입 시 등록한 사항에 관하여 변경이 발생한 경우, 지체없이 ‘회사’에 대하여 회원정보 수정 등의 방법으로 그 변경사항을 알려야 하며 변경사항을 알리지 않아 발생한 불이익에 대하여 ‘회사’는 책임지지 않습니다.
 
제7조 이용계약의 종료
1. ‘회원’의 해지
 (1) ‘회원’은 언제든지 ‘회사’에게 해지의사를 통지함으로써 이용계약을 해지할 수 있습니다.
 (2) ‘회사’는 제1호에 따른 ‘회원’의 해지요청에 대해 특별한 사정이 없는 한 이를 즉시 처리합니다.
 (3) ‘회원’이 계약을 해지하여 계약이 종료되는 경우  ‘회원’이 작성한 게시물 등은 삭제, 페기됩니다.
2. ‘회사’의 해지
 (1) ‘회사’는 다음과 같은 사유가 있는 경우 이용계약을 해지할 수 있습니다. 이 경우 ‘회사’는 ‘회원’에게 전자우편, 전화, 팩스 기타의 방법을 통하여 해지사유를 밝혀 해지의사를 통지합니다. 다만, ‘회사’는 해당 ‘회원’에게 해지사유에 대한 의견진술의 기회를 부여할 수 있습니다.
 A. ‘회원’이 ‘회사’나 다른 회원 기타 타인의 권리나 명예를 침해하는 행위를 한 경우
 B. ‘회원’이 ‘회사’의 정책에 위배되는 행위를 하거나 이 약관에서 규정하고 있는 이용의무를 위반하였을 경우
 (2) 이용계약은 ‘회사’가 해지의사를 ‘회원’에게 통지함으로써 종료됩니다. 이 경우 ‘회사’가 해지의사를 ‘회원’이 등록한 전자우편, 전화 기타의 방법을 통해 통지하거나 ‘회사’ 게시판에 게시함으로써 통지를 갈음합니다.
 (3) 위 사항에 따라 ‘회사’의 해지로 인해 이용계약이 종료될 경우 ‘회원’의 모든 게시물들은 삭제, 폐기 됩니다. 단, 형, 민사상의 법률 및 증거보존, 기타 법률에 따라 그 게시물들을 보존하여야 하는 경우 ‘회사’가 임의적으로 정한 별도의 장소에서 보관할 수 있습니다.
 
제8조 개인정보보호의 의무
‘회사’는 ‘정보통신망’등 관계법령이 정하는 바에 따라 ‘회원’의 개인정보를 보호하기 위해 노력합니다. 개인정보의 보호 및 사용에 대해서는 관련법 및 ‘회사’의 개인정보취급방침이 적용됩니다. 다만, ‘회사’의 ‘서비스’ 이외의 링크된 사이트에서는 ‘회사’의 개인정보취급방침이 적용되지 않습니다.
 
제9조 회원의 ID 및 비밀번호에 대한 의무
1. ‘회원’은 자신의 로그인 정보를 제3자에게 이용하게 해서는 안됩니다.
2. ‘회원’은 자신의 로그인 정보를 도난당하거나 제3자가 사용하고 있음을 인지한 경우에는 즉시 ‘회사’에 통보하고 ‘회사’의 조치가 있는 경우에는 그에 따라야 합니다.
3. ‘회원’이 제2항에 따른 통지를 하지 않거나 ‘회사’의 조치에 응하지 아니하여 발생하는 모든 불이익에 대한 책임은 ‘회원’에게 있습니다.
 
제10조 회사의 의무
1. ‘회사’는 관련법과 이 약관이 금지하거나 미풍양속에 반하는 행위를 하지 않으며, 계속적이고 안정적으로 ‘서비스’를 제공하기 위하여 최선을 다하여 노력합니다.
2. ‘회사’는 서비스에 장애가 생길 경우 지체없이 이를 수리 복구하여야 합니다. 다만, 천재지변, 비상사태 또는 그 밖에 부득이한 경우에는 그 서비스를 중단하거나 중지할 수 있습니다. 
3. ‘회사’는 서비스 이용과 관련하여 ‘회원’으로부터 제기된 의견이나 불만이 정당하다고 인정할 경우에는 이를 처리하여야 합니다.
4. ‘회사’는 사업의 폐업 또는 휴업 예정일 30일전까지 특별한 시정이 없는 한 ‘회원’에게 그 사실을 통보하여야 합니다. 이 경우 ‘회사’는 ‘회원’이 등록한 전자우편, 전화 기타의 방법을 통해 통지하거나 ‘회사’ 게시판에 게시함으로써 통지를 갈음합니다.
 
제11조 회원 및 이용자의 의무
1. ‘이용자’는 관계법령 및 이 약관의 규정, ‘회사’의 정책, 이용안내 등 ‘회사’가 통지 또는 공지하는 사항을 준수하여야 하며, 기타 ‘회사’업무에 방해되는 행위를 하여서는 안됩니다.
2. ‘이용자’는 서비스 이용과 관련하여 다음 각 호의 행위를 하여서는 안됩니다.
 (1) 서비스 신청 또는 변경 시 허위내용의 등록
 (2) ‘회사’에 게시된 정보의 허가 받지 않은 변경
 (3) 다른 이용자의 정보를 수집 저장 공개 및 부정하게 사용하는 행위
 (4) ‘회사’가 정한 정보 이외의 정보(컴퓨터 프로그램 등)의 송신 또는 게시
 (5) ‘회사’와 기타 제3자 저작권 등 지적재산권에 대한 침해
 (6) 회사” 및 기타 제3자의 명예를 손상시키거나 업무를 방해하는 행위
 (7) 외설 또는 폭력적인 메시지, 화상, 음성, 기타 공서양속에 반하는 정보를 ‘서비스’에 공개 또는 게시하는 행위
 (8) ‘회사’의 동의 없이 영리를 목적으로 ‘서비스’를 사용하는 행위
 (9) 기타 불법적이거나 부당한 행위
 (10) 자동 접속 프로그램 등을 사용하는 등 정상적인 용법과 다른 방법으로 서비스를 이용하여 회사의 서버에 부하를 일으켜 회사의 정상적인 서비스를 방해하는 행위
3. ‘이용자’는 반드시 본인이 직접 서비스를 이용해야 하며, 이용계약상 지위를 타인에게 양도, 증여하거나 본인 이외의 타인이 서비스를 이용하여 발생하는 문제에 대한 책임은 이용자 본인에게 있습니다.
 
제12조 이용자 게시물 및 관리
1. ‘이용자’가 작성한 게시물에 대하여 그 저작권은 이용자에게 있으며, 이 게시물들에 대한 모든 책임은 이를 게시한 ‘이용자’에게 귀속됩니다.  단, ‘회사’는 ‘이용자’가 게시하거나 등록하는 게시물의 내용이 다음 각 호에 해당한다고 판단되는 경우 해당 게시물을 사전 통지 없이 삭제 또는 임시조치 할 수 있습니다.
 (1) 다른 회원 또는 제3자를 비방하거나 명예를 손상시키는 경우
 (2) 공공질서 및 미풍양속에 위반되는 내용일 경우
 (3) 범죄적 행위에 결부된다고 인정되는 경우
 (4) ‘회사’의 저작권, 제3자의 저작권 등 기타 권리를 침해하는 내용인 경우
 (5) 해당 서비스와 관련 없는 내용인 경우
 (6) ‘회사’의 서비스 약관, 운영정책 등의 내용을 위반할 우려가 있거나 위반행위를 한 경우
2. ‘이용자’의 ‘게시물’이 정보통신망법 및 저작권법 등 관련법에 위반되는 내용을 포함하는 경우 권리자는 관련법이 정한 절차에 따라 해당 ‘게시물’의 게시중단 및 삭제 등을 요청할 수 있으며, ‘회사’는 관련법에 따라 조치를 취하여야 합니다.
3. 본 조에 따른 세부절차는 정보통신망법 및 저작권법이 규정한 범위 내에서 회사가 정한 게시중단요청 서비스에 따릅니다. (게시중단요청 : lifenlife1004@gmail.com )
4. ‘서비스’에 대한 저작권 및 지적재산권은 ‘회사’에 귀속됩니다. 단, ‘이용자’의 게시물 및 제휴계약에 따라 제공된 저작물 등은 제외합니다. ‘회사’는 서비스와 관련하여 ‘이용자’에게 ‘회사’가 정한 이용조건에 따라 부고장, 화환주문, 콘텐츠 등을 이용할 수 있는 이용권만을 부여하며, ‘이용자’는 이를 양도, 판매, 담보제공 등 처분행위를 할 수 없습니다.
 
제13조 서비스의 변경
1. ‘회사’는 상당한 이유가 있는 경우에 운영상, 기술상의 필요에 따라 제공하고 있는 전부 또는 일부 ‘서비스’를 변경할 수 있습니다.
2. ‘회사’는 무료로 제공되는 서비스의 일부 또는 전부를 회사의 정책 및 운영의 필요상 수정, 중단, 변경할 수 있으며, 이에 대하여 관련법에 특별한 규정이 없는 한 ‘이용자’에게 별도의 보상을 하지 않습니다.
 
제14조 서비스의 이용시간 및 중단
1. ‘서비스’의 이용은 ‘회사’의 업무상 또는 기술상 특별한 지장이 없는 한 연중무휴 1일 24시간을 원칙으로 합니다. 다만, 정기점검 등의 필요로 ‘회사’가 정한 날이나 시간은 제외됩니다. 
2. ‘회사’는 ‘서비스’의 원활한 수행을 위하여 필요한 기간을 정하여 사전에 공지하고 ‘서비스’를 중지할 수 있습니다. 단, 불가피하게 긴급한 조치를 필요로 하는 경우 사후에 통지할 수도 있습니다.
3. ‘회사’는 컴퓨터 등 정보통신설비의 보수점검  • 교체 및 고장, 통신의 두절 등의 사유가 발생한 경우에는 ‘서비스’의 전부 또는 일부를 제한하거나 중지할 수 있습니다.
 
제15조 계약 해지 및 이용제한
1. ‘회원’은 언제든지 ‘서비스’ 초기화면의 고객센터를 통하여 이용계약 해지 신청을 할 수 있으며, ‘회사’는 관련법 등이 정하는 바에 따라 이를 즉시 처리하여야 합니다.
2. ‘회원’이 계약을 해지할 경우, 관련법 및 개인정보취급방침에 따라 ‘회사’가 회원정보를 보유하는 경우를 제외하고는 해지 즉시 ‘회원’의 데이터는 소멸됩니다.
 
제16조 손해배상 및 책임제한
1. ‘회사’와 ‘이용자’는 서비스 이용과 관련하여 고의 또는 과실로 상대방에게 손해를 끼친 경우에는 이를 배상하여야 합니다. 단, 회사는 무료로 제공하는 서비스의 이용과 관련하여 개인정보보호 정책에서 정하는 내용에 위반하지 않는 한 어떠한 손해도 책임을 지지 않습니다.
2. ‘회사’는 천재지변, 전쟁, 해킹 등 불가항력적이 사유 또는 ‘이용자’의 귀책사유로 인해  ‘서비스’를 제공할 수 없는 경우에는 ‘서비스’ 이용의 장애에 대하여 책임을 지지 않습니다.
3. ‘회사’는 ‘이용자’가 ‘서비스’에 게시한 게시물의 정보, 자료, 이미지 등 내용에 관하여는 책임을 지지 않습니다.
4. ‘회사’가 이용자 전원을 대상으로 서비스에 관한 내용의 변경 등을 고지하기 위해 사전에 홈페이지 또는 서비스 초기화면 등에 그러한 내용들을 고지하여 게시한 경우, 고지된 서비스 내용에 관하여 인지하지 못한 이용자에 대하여 ‘회사’는 책임을 지지 않습니다.
 
제17조 주문 및 결제
1. ‘이용자’는  온라인주문서비스(수취인 정보의 입력 및 결제수단의 선택 포함) 또는 이와 유사한 방법에 의한 구매를 신청할 수 있습니다.
2. ‘이용자’가 온라인 주문서비스로 주문하는 경우 배송지, 배송지주소, 수취인, 수취인연락처 등 정보에 대한 정확한 정보를 기재해야 하며, ‘이용자’가 입력한 정보 및 그 정보와 관련하여 발생한 책임과 불이익은 ‘이용자’가 부담합니다.
3. ‘회사’는 ‘이용자’의 결제내역을 서비스 화면을 통해 확인할 수 있도록 조치하며, 전자상거래등에서의 소비자보호에 관한 법률 규정에 의해 일정기간 동안 보존할 수 있습니다.
4. 온라인 장례식장 및 온라인 행사장에서 구매한 이모티콘 구매금액은 VAT, 인앱결제수수료, 앱사용수수료(7%)를 제외하고 온라인 장례식장 및 행사장을 만들 때 등록한 회원의 계좌로  온라인 장례식장 및 행사장 종료일 이후 2주 이내 지급 됩니다. 단, 임시공휴일 등 갑작스런 휴일일 경우 그 다음 영업일에 지급 됩니다.

제18조 취소 및 환불
1. ‘서비스, 재화 등’에 대한 취소 및 환불규정은 전자상거래등에서의 소비자보호에 관한 법률 등 관련 법령을 준수합니다. 또한, 주문완료 후 실제 근조화환 등이 배송중인 이후에는 회복할 수 없는 손해가 발생하므로 단순 변심에 의한 청약철회 등은 할 수 없습니다.
2. 결제취소는 고객센터에 유선 접수가 가능하며, 신용카드결제 및 간편결제는 신용카드사 및 해당 결제업체의 환불기준에 의거하여 처리가 완료되는데 시일이 소요될 수 있습니다.
3. 환불요청은 고객센터에 유선 접수가 가능하며, 접수완료일로부터  2주이내 ‘이용자’가 요청한 환불 계좌로 환급하여 드립니다.  단, 임시공휴일 등 갑작스런 휴일일 경우 그 다음 영업일에 환급하여 드립니다.

제19조 기부천사 기능에 대한 규정
1. ‘회사’는 기부자와 수혜자가 서로 연결될 수 있도록 소개·연결 서비스만을 제공합니다.
2. ‘회사’는 기부금품을 직접 수령·보관·분배하지 않습니다.
3. 기부의 실행, 기부금품의 전달, 영수증 발급 및 세무 처리는 전적으로 기부자와 수혜자의 책임 하에 이루어집니다.

제20조 기부자 및 수혜자의 책임
1. 기부자는 본인의 자발적 의사에 따라 기부를 진행하며, 기부 내용에 대한 사실성과 진정성을 보증합니다.
2. 수혜자는 기부금품의 사용 내역과 목적을 명확히 하며, 필요한 경우 기부자에게 정산 자료를 제공해야 합니다.
3. ‘회사’는 기부자와 수혜자 간 발생하는 분쟁, 손해, 세무 문제 등에 대해 법적 책임을 지지 않습니다.

제21조 기부 서비스 이용관련 준수 사항
1. 기부자는 플랫폼 내에 기재하는 기부 내용 및 기부 사실에 대해 허위 또는 과장 표시를 해서는 안됩니다.
2. 기부 내용이 허위로 판명될 경우 발생하는 모든 법적·행정적 책임은 기부자에게 있습니다
3. ‘회사’는 기부자 또는 수혜자가 약관의 의무를 위반하거나 허위 사실을 기재하는 등 서비스 운영에 지장을 초래하는 경우, 사전 통보 없이 해당 회원의 서비스 이용을 일시적 또는 영구적으로 제한할 수 있습니다.

제22조 기부자 및 수혜자 개인정보 보호
1. 기부자와 수혜자의 연결 과정에서 필요한 최소한의 개인정보(연락처, 이메일 등)는 상호 동의 하에 공유됩니다.
2. ‘회사’는 개인정보를 직접 수집·보관하지 않으며, 단순 전달·연결의 기능만 수행합니다.

제23조 기부 관련 면책 조항
1.  ‘회사’는 기부의 성사 여부, 기부금품의 전달·사용, 기부에 따른 세무 처리 및 법적 분쟁에 대하여 책임을 지지 않습니다.
2.  ‘회사’는 단순히 연결의 장을 제공할 뿐이며, 모든 기부 행위는 기부자와 수혜자 간의 독립적인 행위로 간주됩니다.

제24조 준거법 및 재판관할
1. ‘회사’와 ‘이용자’간 제기된 소송은 대한민국법을 준거법으로 합니다.
2. ‘회사’와 ‘이용자’간 발생한 분쟁에 대해 소송이 제기될 경우 ‘회사’의 본사 소재지를 관할하는 법원을 전속 관할법원으로 합니다.
 
부칙
서비스이용약관 ver. 1
1. 이 약관은 2025년 11월 1일부터 적용됩니다.
2. 회사는 약관을 변경하는 경우에 이용자가 그 변경 여부, 변경된 사항의 시행시기와 변경된 내용을 언제든지 쉽게 할 수 있도록 지속적으로 ‘서비스’를 통하여 공개합니다.

`,
  PRIVACY: `
  추모 개인정보 처리방침
적용 일자 : 2024-00-00
주식회사 점프(이하 "회사")은(는) Life END Life 제공함에 있어 정보주체의 자유와 권리 보호를 위해 「개인정보 보호법」 및 관계 법령이 정한 바를 준수하여, 적법하게 개인정보를 처리하고 안전하게 관리하고 있습니다. 이에 「개인정보 보호법」 제30조 및 관련 시행령에 따라 정보주체에게 개인정보 처리에 관한 절차 및 기준을 안내하고, 이와 관련한 고충을 신속하고 원활하게 처리할 수 있도록 하기 위하여 다음과 같이 개인정보 처리방침을 수립·공개합니다.
  
목차
◾️ 개인정보의 처리목적, 수집 항목, 보유 및 이용기간
◾️ 만 14세 미만 아동의 개인정보 처리에 관한 사항
◾️ 개인정보의 제3자 제공
◾️ 개인정보 처리 업무의 위탁
◾️ 개인정보의 파기 및 절차
◾️ 정보주체와 법정대리인의 권리·의무 및 행사방법
◾️ 개인정보의 안전성 확보조치
◾️ 개인정보 자동 수집 장치의 설치·운영 및 거부에 관한 사항
◾️ 행태정보의 수집·이용 및 거부 등에 관한 사항
◾️ 개인정보 보호책임자 및 개인정보 열람청구
◾️ 권익침해 구제 방법


◾️ 개인정보의 처리목적, 수집 항목, 보유 및 이용기간
① 회사가 처리하고 있는 개인정보의 항목과 목적, 보유 및 이용기간은 아래와 같습니다.
구분(업무명)\t처리 목적\t처리 항목\t보유 및 이용기간
(웹/앱) 이용자 관리\t•\t본인 식별·인증
•\t각종고지·통지사항전달\t필수 : 이름, 휴대전화번호\t•\t정보수집일로부터1년
•\t서비스이용종료시까지
(웹/앱) 회원가입 및 관리\t•\t본인 식별·인증
•\t회원자격 유지·관리
•\t각종고지·통지사항전달
•\t서비스부정가입및이용방지\t필수 : 이름, 생년월일, 성별, 휴대전화번호, CI(연계정보), DI(중복가입확인정보)\t•\t회원 탈퇴 시까지
(웹/앱) 모바일 부고 서비스\t•\t모바일 부고 작성
•\t모바일 부고 공유
•\t부고장 목록 검색
•\t부고장 수정 및 복사\t필수 : 고인이름, 고인나이, 고인직분, 고인종교, 고인성별, 고인임종일, 고인입관일, 고인발인일, 상주이름, 고인과의 관계, 장례식장명, 장례식장 호실, 상주 휴대전화번호, 대표상주 이름, 대표상주 휴대전화번호, 상주 계좌정보(계좌번호, 은행명, 예금주)
선택 : 장지, 고인사진, 알림글, 입실일시, 퇴실일시, 부고장 비밀번호\t•\t정보수집일로부터1년
•\t서비스이용종료시까지
(웹/앱) 기일 및 생일, 기념일 등 알림 서비스\t•\t기일,생일, 기념일 등 알림톡/문자 발송\t필수 : 고인명, 고인임종일, 생일, 기념일 등, 신청인, 연락처
선택 : 고인사진\t•\t신청일로부터 3년
(앱) 장례식장 정보 제공\t•\t실시간 장례식장 정보 제공
•\t장례식장 통화 기록 확인\t필수 : 휴대전화번호, 통화정보(통화성공여부, 통화시작 및 종료시간), 장례식장명, 접속 로그, 서비스 이용 기록\t•\t정보 수집일로부터 1년
•\t서비스 이용 종료 시까지
(앱) 장례식장 안내\t•\t장례식장 길찾기
•\t내 주변 장례식장 안내\t필수 : 위치 정보\t•\t안내 서비스 이용 종료 시까지
(웹/앱) 근조화환 주문 및 배송\t•\t근조화환 상품 안내
•\t근조화환 주문
•\t근조화환 배송
•\t근조화환 배송내역 확인
•\t근조화환 결제 및 환불
•\t주문 이력 관리
•\t구매 영수증 발행\t필수 : 주문자 이름, 주문자 휴대전화번호, 수취인 이름, 상품명, 배송지, 리본 문구, 결제수단정보(신용카드/가상계좌/간편결제), 결제내역, 인수 일시, 배송사진
선택 : 수취인 휴대전화번호, 인수자 관계, 인수자 이름, 환불 계좌정보(은행명, 예금주명, 계좌번호), 지출증빙 발행정보(상호명, 사업자번호, 이메일), 현금영수증 발행정보(이름, 연락처, 이메일)\t•\t법정 의무 보유기간 만료 시까지
(웹) 세무 상담 서비스\t•\t상속/증여/양도 상담 서비스 제공
•\t전문 세무·회계 상담사 연결
•\t유료 상담 결제 및 환불
•\t상담 이력 관리\t필수 : 이름, 휴대전화번호, 문의 내용, 상담유형, 상담 이력, 결제 여부, (유료 상담 시) 결제수단정보
선택 : 이메일주소, 상속 기준일, 부동산 총액, 예금, 주식 총액, 보험금 총액, 부채 총액, 장례비 등 총액, 증여예정일, 증여자와 수증자의 관계, 증여재산의 시가, 증여재산 담보채무금액, 양도예정일, 취득일, 재산의 종류, 양도예정가액, 취득가액\t•\t상담 종료일로부터 1년
(웹) 사망보험금 상담 서비스\t•\t사고/질병/기타 상담서비스
•\t전문 손해사정사 연결
•\t상담 이력 관리\t필수 : 이름, 휴대전화번호, 상담지역, 고인과의 관계, 고인생년월일, 사망구분, 문의구분, 문의 내용
선택 : 이메일주소, 고인이름, 고인사망일\t•\t상담 종료일로부터 1년
(웹/앱) 홍보 및 마케팅\t•\t광고성 정보 전달
•\t상품 및 서비스 추천
•\t프로모션 안내 및 할인쿠폰 발행\t필수 : 이름, 휴대전화번호\t•\t정보 수집일로부터 3년
(웹/앱) 고객 상담 및 문의\t•\t제품 및 서비스 상담
•\t고객 문의 접수 및 처리
•\t고객 불만 사항 처리
•\t문의 접수 및 처리 이력관리\t필수 : 이름, 연락처, 문의 내용
선택 : 서비스 이용 내역, 상담 내역\t•\t법정 의무 보유기간 만료 시까지
(웹/앱) 제휴 문의\t•\t업무 제휴 문의 접수 및 처리
•\t제휴 문의 이력 관리\t필수 : 업체명, 담당자명, 담당자 연락처, 문의 내용
선택 : 이메일주소\t•\t파기 요청 시까지
\t\t\t\t\t
\t\t\t\t\t
\t\t\t\t\t
② 처리하고 있는 개인정보는 상기의 목적 이외의 용도로는 이용되지 않으며, 처리 목적이 변경되는 경우에는 개인정보 보호법 제18조에 따라 별도의 동의를 받는 등 필요한 조치를 이행할 예정입니다.
③ 회사는 법령에 따른 개인정보 보유∙이용기간 또는 정보주체로부터 개인정보를 수집 시에 동의 받은 개인정보 보유∙이용기간 내에서 개인정보를 처리∙보유합니다. 다만, 다음의 사유에 해당하는 경우에는 해당 사유 종료시까지 처리∙보유합니다.
1) 관계 법령 위반에 따른 수사∙조사 등이 진행 중인 경우에는 해당 수사∙조사 종료 시까지
2) 홈페이지 이용에 따른 채권∙채무관계 잔존 시에는 해당 채권∙채무관계 정산 시까지
3) 관련 법령에 따른 의무 보유기간에 해당 시에는 해당 기간 종료 시까지
•\t통신비밀보호법 : 웹사이트 방문 기록(3개월)
•\t전자상거래법 : 계약 또는 청약철회 등에 관한 기록(5년)
•\t전자상거래법 : 대금결제 및 재화 등의 공급에 관한 기록(5년)
•\t전자상거래법 : 소비자의 불만 또는 분쟁처리에 관한 기록(3년)
•\t전자상거래법 : 표시∙광고에 관한 기록(6개월)
•\t정보통신망법 : 본인확인에 관한 기록(6개월)
•\t위치정보보호법 : 개인위치정보에 관한 기록(6개월)
◾️ 만 14세 미만 아동의 개인정보 처리에 관한 사항
① 회사는 만 14세 미만 아동에 대해 개인정보를 수집할 때 법정대리인의 동의를 얻어 해당 서비스 수행에 필요한 최소한의 개인정보를 수집합니다.
② 또한, 아동의 개인정보를 추가로 수집하거나 홍보 및 마케팅을 위하여 처리할 경우에는 법정대리인으로부터 별도의 동의를 얻습니다.
③ 회사는 만 14세 미만 아동의 개인정보를 수집할 때에는 아동에게 법정대리인의 성명, 연락처와 같은 최소한의 정보를 요구할 수 있으며, 다음 중 하나의 방법으로 적법한 법정대리인이 동의하였는지를 확인합니다.
•\t법정대리인이 직접 만 14세 미만 아동의 개인정보를 시스템 상에 입력
◾️ 개인정보의 제3자 제공
① 회사는 정보주체의 개인정보를 개인정보의 처리 목적에서 명시한 범위 내에서만 처리하며, 정보주체의 동의, 법률의 특별한 규정 등 「개인정보 보호법」 제17조 및 제18조에 해당하는 경우에만 개인정보를 제3자에게 제공하고 그 이외에는 정보주체의 개인정보를 제3자에게 제공하지 않습니다.
② 회사는 원활한 서비스 제공을 위해 다음의 경우 정보주체의 동의를 얻어 필요 최소한의 범위로만 제공합니다.
제공받는 자\t제공받는 자의 목적\t제공 항목\t보유 및 이용기간
---법무사무소\t•\t상속/증여/양도 상담
•\t상담 이력 관리\t이름, 휴대전화번호, 문의 내용, 상담유형, 이메일주소, 상속 기준일, 부동산 총액, 예금, 주식 총액, 보험금 총액, 부채 총액, 장례비 등 총액, 증여예정일, 증여자와 수증자의 관계, 증여재산의 시가, 증여재산 담보채무금액, 양도예정일, 취득일, 재산의 종류, 양도예정가액, 취득가액\t•\t서비스 이용 종료 시까지
•\t계약 종료 시까지
---세무그룹\t•\t상속/증여/양도 상담
•\t상담 이력 관리\t이름, 휴대전화번호, 문의 내용, 상담유형, 이메일주소, 상속 기준일, 부동산 총액, 예금, 주식 총액, 보험금 총액, 부채 총액, 장례비 등 총액, 증여예정일, 증여자와 수증자의 관계, 증여재산의 시가, 증여재산 담보채무금액, 양도예정일, 취득일, 재산의 종류, 양도예정가액, 취득가액\t•\t서비스 이용 종료 시까지
•\t계약 종료 시까지
\t•\t상속/증여/양도 상담
•\t상담 이력 관리\t이름, 휴대전화번호, 문의 내용, 상담유형, 이메일주소, 상속 기준일, 부동산 총액, 예금, 주식 총액, 보험금 총액, 부채 총액, 장례비 등 총액, 증여예정일, 증여자와 수증자의 관계, 증여재산의 시가, 증여재산 담보채무금액, 양도예정일, 취득일, 재산의 종류, 양도예정가액, 취득가액\t•\t서비스 이용 종료 시까지
•\t계약 종료 시까지
\t\t\t\t\t
\t\t\t\t\t
\t\t\t\t\t
◾️ 개인정보 처리 업무의 위탁
회사는 원활한 개인정보 업무 처리를 위하여 다음과 같이 개인정보 처리업무를 위탁하고 있습니다.
위탁받는 자(수탁자)\t위탁업무
(주)KT클라우드(앱지 확인)\t•\t클라우드 컴퓨팅을 통한 서비스 인프라 제공
•\t데이터 보관
Google LLC\t•\tGCP(Google Cloud Platform)를 통한 서비스 운영 환경 제공
•\t데이터 보관
(주)누리고(앱지 확인)\t•\t퍼플북을 통한 카카오 알림톡 및 SMS 발송
(주)다우기술(앱지 확인)\t•\t콜믹스를 통한 장례식장 안심번호 서비스 제공
•\t예약자 확인
나이스페이먼츠(주) (앱지 확인)\t•\t전자 결제 대행
•\t요금 정산
•\t계좌실명인증
•\t간편결제 서비스 제공
(주)플라시스템(화환 회사 확인)\t•\t화환 주문 관련 상담
•\t화환 배송업무 대행
나이스평가정보(앱지 확인)\t•\t실명확인 및 본인 인증
◾️ 개인정보의 파기
① 회사는 개인정보 보유기간의 경과, 처리 목적 달성 등 개인정보가 불필요하게 되었을 때에는 지체 없이 해당 개인정보를 파기합니다.
② 정보주체로부터 동의 받은 개인정보 보유기간이 경과하거나 처리 목적이 달성되었음에도 불구하고 다른 법령에 따라 개인정보를 계속 보존하여야 하는 경우에는 다른 고지없이 해당 개인정보를 별도의 데이터베이스(DB)로 옮기거나 보관 장소를 달리하여 보존합니다.
③ 개인정보 파기의 절차 및 방법은 다음과 같습니다.
•\t파기절차 : 파기 사유가 발생한 개인정보를 선정하고 개인정보 보호책임자의 승인을 받아 개인정보를 파기합니다.
•\t파기방법 : 전자적 파일 형태로 기록·저장된 개인정보는 기록을 재생할 수 없도록 파기하며, 종이 문서에 기록·저장된 개인정보는 분쇄기로 분쇄하거나 소각하여 파기합니다.
◾️ 정보주체와 법정대리인의 권리·의무 및 행사방법
① 정보주체는 회사에 대해 언제든지 개인정보 열람·정정·삭제·처리정지 요구 등의 권리를 행사할 수 있습니다.
② 권리 행사는 「개인정보 보호법」 시행령 제41조 제1항에 따라 서면, 전자우편, 모사전송(FAX) 등을 통하여 하실 수 있으며, 회사는 이에 대해 지체 없이 조치하겠습니다.
③ 권리 행사는 정보주체의 법정대리인이나 위임을 받은 자 등 대리인을 통하여 하실 수도 있습니다. 이 경우 "개인정보 처리 방법에 관한 고시(제2020-7호)" 별지 제11호 서식에 따른 위임장을 제출하셔야 합니다.
④ 개인정보 열람 및 처리정지 요구는 「개인정보 보호법」 제35조 제4항, 제37조 제2항에 의하여 정보주체의 권리가 제한될 수 있습니다.
⑤ 개인정보의 정정 및 삭제 요구는 다른 법령에서 그 개인정보가 수집 대상으로 명시되어 있는 경우에는 그 삭제를 요구할 수 없습니다.
⑥ 회사는 정보주체 권리에 따른 열람의 요구, 정정·삭제의 요구, 처리 정지의 요구 시 열람 등 요구를 한 자가 본인이거나 정당한 대리인인지를 확인하고 정당한 요구권자가 아닐 경우 이를 거부합니다.
◾️ 개인정보의 안전성 확보조치
회사는 개인정보의 안전성 확보를 위해 다음과 같은 조치를 취하고 있습니다.
1) 관리적 조치 : 내부관리계획 수립·시행, 전담조직 운영, 정기적 직원 교육
2) 기술적 조치 : 개인정보처리시스템 등의 접근 권한 관리, 접근통제시스템 설치, 개인정보의 암호화, 보안 프로그램 설치 및 갱신
◾️ 개인정보 자동 수집 장치의 설치·운영 및 거부에 관한 사항
회사는 정보주체의 이용정보를 저장하고 수시로 불러오는 "쿠키(cookie)"를 사용하지 않습니다.
◾️ 행태정보의 수집·이용 및 거부 등에 관한 사항
회사는 온라인 맞춤형 광고 등을 위한 행태정보를 수집∙이용∙제공하지 않습니다.
◾️ 개인정보 보호책임자 및 개인정보 열람청구
① 회사는 개인정보 처리에 관한 업무를 총괄해서 책임지고, 개인정보 처리와 관련한 정보주체의 불만 처리 및 피해 구제 등을 위하여 아래와 같이 개인정보 보호책임자를 지정하고 있습니다.
② 정보주체는 「개인정보 보호법」 제35조에 따른 개인정보의 열람 청구를 아래의 연락처로 할 수 있습니다. 회사는 정보주체의 개인정보 열람 청구가 신속하게 처리되도록 노력하겠습니다.
구분\t담당자\t연락처
개인정보 보호책임자\t직책/직위 : 정보보안이사
담당자 성명 : 김성철\tlifenlife1004@gmail.com
개인정보 열람 청구\t부서명 : 디자인팀
담당자 성명 : 이효진\tlifenlife1004@gmail.com
③ 정보주체는 회사의 서비스(또는 사업)을 이용하시면서 발생한 모든 개인정보보호 관련 문의, 불만 처리, 피해 구제 등에 관한 사항을 개인정보 보호책임자 및 담당부서로 문의할 수 있습니다. 회사는 정보주체의 문의에 대해 지체 없이 답변 및 처리해 드릴 것입니다.
◾️ 권익침해 구제 방법
① 회사는 정보주체의 개인정보 자기 결정권을 보장하고, 개인정보 침해로 인한 상담 및 피해 구제를 위해 노력하고 있으며, 신고나 상담이 필요한 경우 담당부서로 연락해 주시기 바랍니다.
② 정보주체는 개인정보 침해로 인한 구제를 받기 위하여 개인정보 분쟁조정위원회, 한국인터넷진흥원 개인정보 침해신고센터 등에 분쟁해결이나 상담 등을 신청할 수 있습니다. 이 밖에 기타 개인정보 침해의 신고, 상담에 대하여는 아래의 기관에 문의하시기 바랍니다.
•\t개인정보분쟁조정위원회 : (국번없이) 1833-6972 (www.kopico.go.kr)
•\t개인정보침해신고센터 : (국번없이) 118 (privacy.kisa.or.kr)
•\t대검찰청 : (국번없이) 1301 (www.spo.go.kr)
•\t경찰청 : (국번없이) 182 (ecrm.cyber.go.kr)
③ 「개인정보 보호법」 제35조(개인정보의 열람), 제36조(개인정보의 정정·삭제), 제37조(개인정보의 처리정지 등)의 규정에 의한 요구에 대하여 공공기관의 장이 행한 처분 또는 부작위로 인하여 권리 또는 이익의 침해를 받은 자는 행정심판법이 정하는 바에 따라 행정심판을 청구할 수 있습니다.
•\t중앙행정심판위원회 : (국번없이) 110 (www.simpan.go.kr)
◾️ 개인정보 처리방침의 변경에 관한 사항
본 방침은 2024년 00월 00일부터 시행됩니다.

`
};

export const TERMS_OBJECT = {
  SERVICE: {
    terms: TERMS_KANPANON_V1,
    text: '[필수] 서비스 이용약관',
    titleName: '서비스 이용약관'
  },
  PRIVACY: {
    terms: TERMS_TEXT.PRIVACY,
    text: '[필수] 개인정보 취급방침',
    titleName: '개인정보 취급방침'
  },
  MARKETING: {
    terms: TERMS_KANPANON_V1,
    text: '[선택] 마케팅 정보 동의',
    titleName: '마케팅 정보 동의'
  },
  ALL: {
    text: '모든 약관에 동의합니다.'
  }
};

// sorting : InfoItem 의 앞에 붙는 기호? 값 숫자인지 도트(점)인지
export const INFO_BOX_OBJECT = {
  SIGN_UP: {
    title: '가족 대표 ID로 설정하시겠습니까?',
    subTitle: '가족 대표 ID 설정 시 변경이 향후 불가능하니 주의 바랍니다.',
    infoTitle: '가족 대표 ID는 아래의 메뉴를 사용하실 수 있습니다.',
    sorting: 'number',
    leftBtn: '미설정',
    rightBtn: '설정',
    items: ['가족 코드 발급', '고인 등록', '추모관 설정 및 관리', '추모관 > 생전모습 관리', '헌화하기 관리']
  },
  MEMORIAL_STEP1: {
    title: '추모관 이용권',
    subTitle: '이용기간 만료 시 해당 제품은 사용할 수 없습니다.',
    sorting: 'dot',
    singleBtn: '이용권 구매하기',
    items: [
      // '1인 추모관 선택시 1명의 고인정보를 등록할 수 있습니다.',
      // '부부합장 추모관 선택 시 2명의 고인정보를 등록할 수 있습니다.',
      // '부부합장 추모관 선택 시 부부합장 추모관 이용권만 사용 가능합니다.',
      '추모관 유형 선택시 추후 변경이 불가능하니 주의바랍니다.'
    ]
  },
  MEMORIAL_STEP3: {
    title: '추모관 배경 이미지 설정',
    subTitle: '추모관 배경이미지 설정은 추후 변경 가능합니다.',
    infoTitle: '추모관 배경이미지 설정을 선택해 주세요.',
    sorting: 'dot',
    leftBtn: '배경이미지 둘러보기',
    rightBtn: '배경이미지 직접등록',
    items: [
      '배경이미지 둘러보기를 통해 배경이미지를 구매 또는 선택할 수 있습니다.',
      '추모관 배경 이미지를 고인이 안치된 실제 사진으로 직접 등록하면 고인 영정과 액자는 미노출 됩니다.'
    ]
  },
  MEMORIAL_REGISTER_P: [
    '배경이미지 둘러보기를 통해 배경이미지를 구매 또는 선택할 수 있습니다.',
    '추모관 배경 이미지를 고인이 안치된 실제 사진으로 직접 등록하면 고인 영정과 액자는 미노출 됩니다.',
    '추모관 배경 이미지 설정은 추후 변경 가능합니다.'
  ],
  MEMORIAL_REGISTER_NOT_P: [
    '배경이미지 둘러보기를 통해 배경이미지를 구매 또는 선택할 수 있습니다.',
    '추모관 배경 이미지 설정은 추후 변경 가능합니다.'
  ]
};

export const CHURCH_JOB_LIST = ['목사', '사모', '강도사', '전도사', '장로', '권사', '안수집사', '(서리)집사', '성도'];
export const BEFORE_SEND_LIST = [
  { key: 0, value: '당일' },
  { key: 3, value: '3일 전' },
  { key: 7, value: '7일 전' }
];

export const RELATION_LIST = ['직접입력', '배우자', '아들', '딸', '며느리', '사위', '손자', '손녀', '외손자', '외손녀'];

export const CRY_RELATION_LIST = [
  '직접입력',
  '배우자',
  '부',
  '모',
  '아들',
  '딸',
  '며느리',
  '사위',
  '손자',
  '손녀',
  '외손자',
  '외손녀'
];

export const ANDERSEN_RELATION_LIST = ['직접입력', '부', '모'];

export const WEDDING_RELATION_LIST = ['부', '모', '부모', '자녀', '배우자', '기타(직접입력)'];

export const BANK_LIST = [
  {
    content: 'KB 국민은행',
    value: 'KB 국민은행'
  },
  {
    content: '기업은행',
    value: '기업은행'
  },
  {
    content: 'NH 농협은행',
    value: 'NH 농협은행'
  },
  {
    content: '신한은행',
    value: '신한은행'
  },
  {
    content: '우체국',
    value: '우체국'
  },
  {
    content: 'SC 제일은행',
    value: 'SC 제일은행'
  },
  {
    content: 'KEB 은행',
    value: 'KEB 은행'
  },
  {
    content: '한국시티은행',
    value: '한국시티은행'
  },
  {
    content: '우리은행',
    value: '우리은행'
  },
  {
    content: '광주은행',
    value: '광주은행'
  },
  {
    content: '대구은행',
    value: '대구은행'
  },
  {
    content: '부산은행',
    value: '부산은행'
  },
  {
    content: '한국산업은행',
    value: '한국산업은행'
  },
  {
    content: '수협중앙회',
    value: '수협중앙회'
  },
  {
    content: '전북은행',
    value: '전북은행'
  },
  {
    content: '제주은행',
    value: '제주은행'
  },
  {
    content: '새마을금고',
    value: '새마을금고'
  },
  {
    content: '상호저축은행',
    value: '상호저축은행'
  },
  {
    content: '신협중앙회',
    value: '신협중앙회'
  },
  {
    content: '산림조합중앙회',
    value: '산림조합중앙회'
  },
  {
    content: '한국투자증권',
    value: '한국투자증권'
  },
  {
    content: '케이뱅크',
    value: '케이뱅크'
  },
  {
    content: '카카오뱅크',
    value: '카카오뱅크'
  },
  {
    content: '토스뱅크',
    value: '토스뱅크'
  }
];

export default {
  CODE_ENV_LIST,
  JOIN_TYPE,
  MODE
};
